import Box from '@mui/material/Box'
import {forwardRef} from "react";
import {useTheme} from "@mui/material";
import {merge} from 'lodash';

const Flex = forwardRef(({ children, justifyContent, alignItems, flexDirection, flexGrow, gap, className, fullWidth, fullHeight, sx, p, px, py, pt, pb }, ref) => {
  const theme = useTheme();
  return (
    <Box
      sx={merge({
        display: "flex",
        justifyContent: justifyContent || 'flex-start',
        alignItems: alignItems || 'flex-start',
        flexDirection: flexDirection || 'row',
        flexGrow: flexGrow,
        gap: gap || 0,
        width: fullWidth ? "100%" : undefined,
        height: fullHeight ? "100%" : undefined,
        position: "relative",
      }, sx)}
      px={px || p}
      pt={pt || py || p}
      pb={pb || py || p}
      className={className}
      ref={ref}
    >
      {children}
    </Box>
  );
});

export default Flex
